import { Container, Eyebrow, Reveal } from "../components/site/primitives";
import { SegmentCard, CTABanner } from "../components/site/blocks";
import { SEGMENT_LIST } from "../lib/content";
import Seo from "../components/site/Seo";

export default function WhoWeServe() {
  return (
    <>
      <Seo
        title="Who We Serve | Community Tax Partner Solutions by Industry"
        description="Tailored tax debt resolution partnerships for fintechs, lenders, tax software providers, law firms, and financial advisors."
        path="/who-we-serve"
      />
      <section className="pt-16 pb-12 lg:pt-24">
        <Container>
          <Eyebrow>Who We Serve</Eyebrow>
          <Reveal>
            <h1 className="font-display font-extrabold text-[#1E1E24] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl">
              Built for Every Financial, Tax, and Legal Workflow
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-[#40424D] leading-relaxed max-w-2xl">
              Tax debt shows up differently depending on where you sit in the transaction. Choose
              your industry to see exactly where it breaks — and how Community Tax resolves it before
              it costs you the relationship.
            </p>
          </Reveal>
        </Container>
      </section>

      <section className="pb-20 lg:pb-28">
        <Container>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {SEGMENT_LIST.map((s, i) => (
              <SegmentCard key={s.slug} segment={s} index={i} />
            ))}
          </div>
        </Container>
      </section>

      <CTABanner />
    </>
  );
}
